import React, { useState } from "react";
import "./NotifyModal.scss"
import Button from "../../../components/Button/Button";
import InputComponent from "../../../components/InputComponent/InputComponent";
import close from "../../../assets/close.svg"
import config from "react-global-configuration";
import NotifyEmail from "../../../email/NotifyEmail";
import { renderEmail } from 'postonents';

const NotifyModal = ({ setIsVisible, product, setIsFailedVisible, setIsSuccessVisible }) => {
    const [email, setEmail] = useState("")
    const [errors, setErrors] = useState({ email: "" })
    const [isLoading, setIsLoading] = useState(false)

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const newErrors = {
            email: "",
        };
        if (email.trim() === "") {
            newErrors.email = "*required";
            valid = false;
        } else if (!validateEmail(email)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    }
    const handleNotify = () => {
        if (validateForm() && !isLoading) {
            setIsLoading(true)
            const Notifydata = {
                companyPageTitle: config.get("companyPageTitle"),
                SenderEmail: config.get("SenderEmail"),
                companyLogoCDN: config.get("companyLogoCDN"),
                prdtName: product,
            };
            const emailBody = renderEmail(NotifyEmail, { lang: "en", Notifydata });
            async function postData() {
                const ecoEmail = {
                    to: "koles20798@cyluna.com",
                    from: email,
                    subject: "Product Notification Request",
                    html: emailBody,
                };

                const response = await fetch(config.get("backendURL") + "mail/send", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(ecoEmail),
                });
                return response.json();
            }

            postData().then((data) => {
                if (data === 'SUCCESS') {
                    setIsLoading(false)
                    setEmail("")
                    setIsVisible(false)
                    setIsSuccessVisible(true)
                } else {
                    setIsFailedVisible(true)
                    setIsLoading(false)

                }
            });
        }
    }
    return (
        <div className="NotifyModal">
            <div className="NotifyModal-content">
                <div className="modal-img-container">
                    <img alt="" src={close} onClick={() => {
                        setIsVisible(false)
                    }} />
                </div>
                <div className="modal-header-text">Get Notified When Available !</div>
                <div className="modal-sub-text">Enter your email address and we'll let you know as soon as this product is available.</div>

                <div className="input-container">
                    <InputComponent
                        isError={errors.email !== ""}
                        errorMessage={errors.email}
                        layout="layout1" placeholder="Email*" value={email} onChange={e => setEmail(e.target.value)} />

                </div>

                <div className="modal-btn-cont">
                    <Button
                        text={"Submit"}
                        width={"50%"} onClick={handleNotify}

                        isLoading={isLoading} />
                </div>

            </div >

        </div >
    )
}
export default NotifyModal